// Custom components
import useApi from '@/lib/api/useApi';

export type GraphData = {
  stat_current_month: {
    day: string,
    count: number
  }[],
  stat_previous_month: {
    day: string,
    count: number
  }[],
  stat_current_month_per_user: {
    username: string,
    count: number
  }[],
  stat_previous_month_per_user: {
    username: string,
    count: number
  }[],
  current_time: {
    current_month: number,
    current_year: number
  }
}

export interface IAdminService {
  getLoginStats: (tenantId: number) => Promise<any>;
}

function getLoginStats(tenantId: number): Promise<any> {
  const api = useApi();
  const url = `system/tenants/${tenantId.toString()}/login-stats`;

  return api.get(url);
}


export const adminService: IAdminService = {
  getLoginStats,
};
